import { ForwardedRef, forwardRef } from "react"
import { Flex } from "../../../../../components/flex/Flex"
import { FormInput, InputProps } from "./Input"
import Text from "../../../../../components/Text"

function EanInputPrefix(props: { value: string }) {
  return (
    <Flex align="center" justify="center" css={{ height: "100%", width: "100%" }}>
      <Text type="textsLarge" color="primary">
        {props.value}
      </Text>
    </Flex>
  )
}

type Props = Omit<InputProps, "type" | "leftContent" | "placeholder" | "label"> & {
  prefix: string
}

function EanInputRaw(props: Props, ref: ForwardedRef<HTMLInputElement>) {
  const { id, prefix, ...inputProps } = props
  return (
    <FormInput
      id={id}
      ref={ref}
      type="text"
      leftContent={<EanInputPrefix value={prefix} />}
      placeholder="XXXXXXXXXXX, přesně jedenáct číslic"
      {...inputProps}
    />
  )
}

export const EanInput = forwardRef(EanInputRaw)
